import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import type { GroupTagUpdateItem } from '@/types';
import { getLocationFor } from '@trinity/chat-components';
import List from './Tags.List';

export default function Readonly() {
  const navigate = useNavigate();

  const handleClick = useCallback((tag: GroupTagUpdateItem) => {
    const location = getLocationFor.workspaces.search({
      keywords: [tag.name],
    });
    navigate(location);
  }, [navigate]);

  return <List onClick={handleClick} />;
}

export { Readonly };